import React from "react";

interface TableRowProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLTableRowElement>,
    HTMLTableRowElement
  > {
  children: React.ReactNode;
}

export const TableRow = ({ children, ...rest }: TableRowProps) => {
  return (
    <tr className="cursor-pointer" {...rest}>
      {children}
    </tr>
  );
};
